var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-dashboard"},[_c('div',{staticClass:"main-content"},[_c('withdraw-on-temp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }